import { render, staticRenderFns } from "./restore-password.vue?vue&type=template&id=84a23c52&scoped=true&"
import script from "./restore-password.vue?vue&type=script&lang=js&"
export * from "./restore-password.vue?vue&type=script&lang=js&"
import style0 from "./restore-password.vue?vue&type=style&index=0&id=84a23c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a23c52",
  null
  
)

export default component.exports